import React, { ReactElement, useState, useEffect } from 'react';
import './index.less';
import { useLocation, useHistory } from 'react-router-dom';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import Toast from '../../../../components/toast';
import FullLoading from '../../../../components/full-loading';
import { getInstallProgress, confirmRes } from '../../../../api/filling-pile';
import { formateDatePile, getPlatform } from '../../../../utils/common';
import { getLoginInfoPromise } from '../../../../utils/common';
import { querySharePileInfo } from '../../../pile-sharing-manage/api';
import { resolveImageUrl } from '../../../../utils/oss_tools';


export default function InstallingReport(): ReactElement {
  const loc = useLocation();
  const router = useHistory();
  const params = new URLSearchParams(loc.search);
  const [installInfo, setInstallInfo] = useState<any>();
  const [orderInfo, setOrderInfo] = useState<any>();
  const [pileShareInfo, setPileShareInfo] = useState<any>({})
  const [userName, setUserName] = useState<any>();
  const [info, setInfo] = useState<any>();
  const [resolvedPicUrls, setResolvedPicUrls] = useState<string[]>([]);
  const estimatesFee = () => {
    let sum = 0;
    if (
      installInfo.installSelfFeeProject &&
      installInfo.installSelfFeeProject.length > 0
    ) {
      installInfo.installSelfFeeProject.forEach(item => {
        sum += item.amount * item.price;
      });
      return Math.round(sum * 100) / 100;
    }
    return Math.round(sum * 100) / 100;
  };
  const actionAfterConfirm = (msg) => {
    const isOpeningStatus = [1, 6]
    if (!pileShareInfo?.hasPile) {
      Toast.show({
        text: msg,
        duration: 2000
      });
    } else {
      if (pileShareInfo?.isPileMaterialVersionMatch) {
        if (pileShareInfo?.hasStation) {
          Toast.show({
            text: msg,
            duration: 2000
          });
        } else {
          if (!pileShareInfo?.hasOpenApply) {
            Toast.show({
              text: msg,
              duration: 2000
            });
            localStorage.setItem('openSimpleShareModalAfterConfirm', '1')
          } else {
            if (isOpeningStatus.includes(pileShareInfo?.openApplyStatus)) {
              Toast.show({
                text: msg,
                duration: 2000
              });
            } else {
              Toast.show({
                text: msg,
                duration: 2000
              });
              localStorage.setItem('openSimpleShareModalAfterConfirm', '1')
            }
          }
        }
      } else {
        Toast.show({
          text: msg,
          duration: 2000
        });
      }
    }
    router.goBack();
  }
  const confirmResult = () => {

    FullLoading.show({
      text: '确认中'
    });
    const uid: any = params.get('uid');
    const param = {
      installSelfFeeProject: info.installSelfFeeProject,
      realInstallFee: estimatesFee(),
      operateType: 'user'
    };
    confirmRes({
      uid,
      name: userName,
      taskId: info.taskId,
      orderNo: info.orderNo,
      operateCode: '07',
      equipmentCode: info.equipmentCode,
      param
    })
      .then(res => {
        FullLoading.hide();
        if (res.data.code === 200) {
          localStorage.setItem('coupons', 'coupons')
          actionAfterConfirm('服务完成，已自动为你绑定充电桩')
        } else {
          localStorage.setItem('coupons', 'coupons')
          actionAfterConfirm('服务完成')
        }
      })
      .catch(err => {
        console.log('err', err);
        Toast.show({
          text: err.message,
          duration: 2000
        });
        FullLoading.hide();
      });
  };
  const setTitle = () => {
    document.title = '安装报告';
  };
  useEffect(() => {
    console.log('进入安装报告')
    setTitle();
    // FullLoading.show({
    //   text: '加载中'
    // });


    const orderNo: any = params.get('orderNo');
    console.log('页面', orderNo);
    getLoginInfoPromise()
      .then(res => {
        const phoneModel = getPlatform();
        let name: string = res.username;
        if (phoneModel === 'android') {
          name = res.nickname;
        }
        setUserName(name);
        console.log('1');
      })
      .catch(err => {
        console.log(err);
        FullLoading.hide();
        console.log('2');
      });
    getLoginInfoPromise()
      .then(res => {
        console.log('3', res.uid, orderNo);
        getInstallProgress({ uid: res.uid, orderNo }).then(info => {
          console.log('6', info);
          setInfo(info && info.data);
          console.log(JSON.parse(info && info.data.installationInfo));
          setOrderInfo(info && info.data);
          setInstallInfo(JSON.parse(info && info.data.installationInfo));
          // 解析安装图片 URL（type=1/2 走加密适配器）
          if (info?.data?.installPictureList) {
            Promise.all(
              info.data.installPictureList.map(async (pic: any) => {
                if ([1, 2].includes(pic.type)) {
                  return resolveImageUrl(pic);
                }
                return pic.ossUrl || '';
              })
            ).then(urls => setResolvedPicUrls(urls));
          }
          FullLoading.hide();
        });
      })
      .catch(err => {
        console.log(err);
        FullLoading.hide();
        console.log('5');
      });


    querySharePileInfo().then(pileShareRes => {
      console.log(pileShareRes, 'pileShareRes')
      if ([0, 200].includes(pileShareRes.code)) {
        setPileShareInfo(pileShareRes?.data || {})
      }
    })
  }, []);
  return (
    <div className="report">
      <div className="info">
        <div className="info-title" style={{ fontWeight: 700 }}>
          安装信息
        </div>
        <div className="install-time">
          <div className="text">安装时间</div>
          <div className="date">
            {orderInfo && formateDatePile(orderInfo.installationFinishDate)}
          </div>
        </div>
        <div className="install-fee">
          <div className="text">安装费用</div>
          <div className="num">{installInfo && estimatesFee()}元</div>
        </div>
        <div className="tips-text">
          确认安装结果表示您认可服务商的安装质量，并对自费项目没有异议。同时，服务商已完成了对您的设备使用和简易故障排查培训。
        </div>
        <div className="photo" style={{ fontWeight: 700 }}>
          现场照片
        </div>
        <PhotoProvider>
          <div className="photo-item">
            {info &&
              info.installPictureList.map((path, index) => (
                <PhotoView src={resolvedPicUrls[index] || path.ossUrl} key={index}>
                  <img src={resolvedPicUrls[index] || path.ossUrl} alt="" />
                </PhotoView>
              ))}
          </div>
        </PhotoProvider>
        <div className='auto-confirm'>
          {
            info && JSON.parse(info.installationInfo).operateType === 1 ? <p>
              提示:超时未确认,系统已自动确认
            </p> : null
          }
        </div>
      </div>
      <div className="btn">
        {info && info.orderStatus === '18' ? (
          <button className="report-btn" onClick={confirmResult}>
            确认安装结果
          </button>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
